import { LessonCurriculumOutcome } from "@/ts/interfaces/Reporting/api/LessonCurriculamInterface";
import { PayloadAction, createSlice } from "@reduxjs/toolkit";
import { getLessonCurriculumOutcomesThunk } from "../thunks";
import { REQUEST_STATUS } from "@/ts/enums/RequestStatus";

interface LessonCurriculumState {
    status: REQUEST_STATUS;
    isLoading: boolean;
    isSuccess: boolean;
    error: string | null;
    data: LessonCurriculumOutcome[];
}

const initialState: LessonCurriculumState = {
    status: REQUEST_STATUS.IDLE,
    isLoading: false,
    isSuccess: false,
    error: null,
    data: []
};

const reportingLessonCurriculumSlice = createSlice({
    name: "reporting/lessonCurriculum",
    initialState,
    reducers: {
        resetLessonCurriculumState: () => initialState
    },
    extraReducers: builder => {
        builder
            .addCase(getLessonCurriculumOutcomesThunk.pending, state => {
                state.status = REQUEST_STATUS.PENDING;
                state.isLoading = true;
                state.isSuccess = false;
                state.error = null;
            })
            .addCase(
                getLessonCurriculumOutcomesThunk.fulfilled,
                (state, action: PayloadAction<LessonCurriculumOutcome[]>) => {
                    state.status = REQUEST_STATUS.SUCCESS;
                    state.isLoading = false;
                    state.isSuccess = true;
                    state.data = action.payload;
                }
            )
            .addCase(
                getLessonCurriculumOutcomesThunk.rejected,
                (state, action) => {
                    state.status = REQUEST_STATUS.ERROR;
                    state.isLoading = false;
                    state.isSuccess = false;
                    state.error = action.payload ?? "Unknown error";
                }
            );
    }
});

export const { resetLessonCurriculumState } =
    reportingLessonCurriculumSlice.actions;
export default reportingLessonCurriculumSlice.reducer;
